export default {
    getUserInfo(state) {
        return state.userInfo;
    }
}
